import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PortfolioGallery = ({ portfolio }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000)?.toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000)?.toFixed(1) + 'K';
    }
    return num?.toString();
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Portföy Galerisi</h2>
        <span className="text-sm text-muted-foreground">{portfolio?.length} içerik</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {portfolio?.map((item) => (
          <div
            key={item?.id}
            className="group relative bg-muted rounded-lg overflow-hidden cursor-pointer hover:shadow-elevation-2 transition-smooth"
            onClick={() => setSelectedItem(item)}
          >
            <div className="relative h-64 overflow-hidden">
              <Image
                src={item?.thumbnail}
                alt={item?.thumbnailAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-smooth" />
              
              <div className="absolute top-2 right-2 px-2 py-1 bg-black/70 rounded-md text-white text-xs font-medium">
                {item?.type}
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-smooth">
                <p className="font-medium mb-2 line-clamp-2">{item?.title}</p>
                <div className="flex items-center gap-4 text-sm">
                  <span className="flex items-center gap-1">
                    <Icon name="Eye" size={14} />
                    {formatNumber(item?.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="Heart" size={14} />
                    {formatNumber(item?.likes)}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="MessageCircle" size={14} />
                    {formatNumber(item?.comments)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {selectedItem && (
        <div className="fixed inset-0 bg-black/80 z-[2000] flex items-center justify-center p-4" onClick={() => setSelectedItem(null)}>
          <div className="bg-card rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e?.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-foreground">{selectedItem?.title}</h3>
                <button
                  onClick={() => setSelectedItem(null)}
                  className="p-2 hover:bg-muted rounded-lg transition-smooth"
                >
                  <Icon name="X" size={20} />
                </button>
              </div>

              <div className="relative h-96 bg-muted rounded-lg overflow-hidden mb-4">
                <Image
                  src={selectedItem?.thumbnail}
                  alt={selectedItem?.thumbnailAlt}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="grid grid-cols-3 gap-4 mb-4">
                <div className="p-4 bg-muted rounded-lg text-center">
                  <Icon name="Eye" size={20} className="mx-auto mb-2 text-primary" />
                  <p className="text-xl font-bold text-foreground">{formatNumber(selectedItem?.views)}</p>
                  <p className="text-sm text-muted-foreground">Görüntülenme</p>
                </div>
                <div className="p-4 bg-muted rounded-lg text-center">
                  <Icon name="Heart" size={20} className="mx-auto mb-2 text-error" />
                  <p className="text-xl font-bold text-foreground">{formatNumber(selectedItem?.likes)}</p>
                  <p className="text-sm text-muted-foreground">Beğeni</p>
                </div>
                <div className="p-4 bg-muted rounded-lg text-center">
                  <Icon name="MessageCircle" size={20} className="mx-auto mb-2 text-accent" />
                  <p className="text-xl font-bold text-foreground">{formatNumber(selectedItem?.comments)}</p>
                  <p className="text-sm text-muted-foreground">Yorum</p>
                </div>
              </div>

              <p className="text-muted-foreground mb-4">{selectedItem?.description}</p>

              <div className="flex items-center justify-between pt-4 border-t border-border">
                <span className="text-sm text-muted-foreground">{selectedItem?.date}</span>
                <Button variant="outline" iconName="ExternalLink" iconPosition="right">
                  Orijinal İçeriği Görüntüle
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioGallery;